export default __webpack_public_path__ + "static/media/49.9e0619f8.jpg";